import { Button } from "@/shadcn/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shadcn/components/ui/dialog";
import { useAuthContext } from "@/hooks/useAuthContext";
import { ReloadIcon, UploadIcon } from "@radix-ui/react-icons";

import { useEffect, useState } from "react";
import { useUserContext } from "@/hooks/useUserContext";
import Loading from "@/components/Loading";
import Step1 from "./Tutorials/OpenAccount/Step1";
import Step2 from "./Tutorials/OpenAccount/Step2";
import Step3 from "./Tutorials/OpenAccount/Step3";
import Step4 from "./Tutorials/OpenAccount/Step4";
import Step5 from "./Tutorials/OpenAccount/Step5";
import Step6 from "./Tutorials/OpenAccount/Step6";
import Step7 from "./Tutorials/OpenAccount/Step7";
import Step8 from "./Tutorials/OpenAccount/Step8";
import Step9 from "./Tutorials/OpenAccount/Step9";
import Step10 from "./Tutorials/OpenAccount/Step10";
import Step11 from "./Tutorials/OpenAccount/Step11";
import Step12 from "./Tutorials/OpenAccount/Step12";
import Step13 from "./Tutorials/OpenAccount/Step13";
import { useFirestore } from "@/hooks/useFirestore";
import CopyStep1 from "./Tutorials/Copy/Step1";
import CopyStep2 from "./Tutorials/Copy/Step2";
import CopyStep3 from "./Tutorials/Copy/Step3";
import CopyStep4 from "./Tutorials/Copy/Step4";
import CopyStep5 from "./Tutorials/Copy/Step5";
import CopyStep6 from "./Tutorials/Copy/Step6";
import CopyStep7 from "./Tutorials/Copy/Step7";
import CopyStep8 from "./Tutorials/Copy/Step8";
import CopyStep9 from "./Tutorials/Copy/Step9";
import CopyStep10 from "./Tutorials/Copy/Step10";
import CopyStep11 from "./Tutorials/Copy/Step11";
import CopyStep12 from "./Tutorials/Copy/Step12";
import CopyStep13 from "./Tutorials/Copy/Step12";

export function TutorialDialog({ children, tutorialName }) {
  const { user } = useAuthContext();
  const { userDoc } = useUserContext();
  const { updateDocument: updateUser } = useFirestore("users");
  const [isPending, setIsPending] = useState(false);
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (tutorialName === "OpenAccount") {
      if (userDoc.meaningfulActions?.accountTutorial?.step !== 13) {
        setStep(userDoc.meaningfulActions?.accountTutorial?.step || 1);
      } else {
        setStep(1);
      }
    } else if (tutorialName === "CopyTrading") {
      if (userDoc.meaningfulActions?.copyTutorial?.step !== 12) {
        setStep(userDoc.meaningfulActions?.copyTutorial?.step || 1);
      } else {
        setStep(1);
      }
    }
  }, [tutorialName]);

  const getButtonText = () => {
    let btnText = "";
    if (tutorialName === "CopyTrading") {
      if (isLatam && step !== 12) {
        btnText = "Siguiente";
      } else if (isLatam && step === 12) {
        btnText = "Concluir";
      } else if (step === 12) {
        btnText = "Concluir";
      } else {
        btnText = "Próximo";
      }
    } else if (tutorialName === "OpenAccount") {
      if (isLatam && step !== 13) {
        btnText = "Siguiente";
      } else if (isLatam && step === 13) {
        btnText = "Concluir";
      } else if (step === 13) {
        btnText = "Concluir";
      } else {
        btnText = "Próximo";
      }
    }

    return btnText;
  };

  if (!userDoc) return <Loading />;

  const isLatam = userDoc.latam;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[720px] px-2.5 sm:px-5">
        <DialogHeader>
          <DialogTitle className="text-2xl">
            {tutorialName === "OpenAccount"
              ? "Abrindo sua conta na corretora"
              : "Como aderir à estratégia automatizada MAIA™"}
          </DialogTitle>
          <DialogDescription className="text-md">
            {isLatam
              ? "Sigue los pasos de abajo."
              : "Siga o passo-a-passo abaixo."}
          </DialogDescription>
        </DialogHeader>
        {tutorialName === "OpenAccount" && (
          <div className="mt-2.5">
            <div
              className={`${
                step === 1 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step1 />{" "}
            </div>
            <div
              className={`${
                step === 2 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step2 />{" "}
            </div>
            <div
              className={`${
                step === 3 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step3 />{" "}
            </div>
            <div
              className={`${
                step === 4 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step4 />{" "}
            </div>
            <div
              className={`${
                step === 5 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step5 />{" "}
            </div>
            <div
              className={`${
                step === 6 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step6 />{" "}
            </div>
            <div
              className={`${
                step === 7 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step7 />{" "}
            </div>
            <div
              className={`${
                step === 8 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step8 />{" "}
            </div>
            <div
              className={`${
                step === 9 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step9 />{" "}
            </div>
            <div
              className={`${
                step === 10 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step10 />{" "}
            </div>
            <div
              className={`${
                step === 11 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step11 />{" "}
            </div>
            <div
              className={`${
                step === 12 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step12 />{" "}
            </div>
            <div
              className={`${
                step === 13 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <Step13 />{" "}
            </div>
          </div>
        )}
        {tutorialName === "CopyTrading" && (
          <div className="mt-2.5">
            <div
              className={`${
                step === 1 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep1 />{" "}
            </div>
            <div
              className={`${
                step === 2 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep2 />{" "}
            </div>
            <div
              className={`${
                step === 3 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep3 />{" "}
            </div>
            <div
              className={`${
                step === 4 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep4 />{" "}
            </div>
            <div
              className={`${
                step === 5 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep5 />{" "}
            </div>
            <div
              className={`${
                step === 6 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep6 />{" "}
            </div>
            <div
              className={`${
                step === 7 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep7 />{" "}
            </div>
            <div
              className={`${
                step === 8 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep8 />{" "}
            </div>
            <div
              className={`${
                step === 9 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep9 />{" "}
            </div>
            <div
              className={`${
                step === 10 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep10 />{" "}
            </div>
            <div
              className={`${
                step === 11 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep11 />{" "}
            </div>
            <div
              className={`${
                step === 12 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep12 />{" "}
            </div>
            <div
              className={`${
                step === 13 ? "" : "-top-[9999px] -left-[9999px] absolute"
              }`}
            >
              <CopyStep13 />{" "}
            </div>
          </div>
        )}
        <DialogFooter className="mt-5">
          <div className="flex justify-center w-full gap-2.5">
            <Button
              variant="outline"
              disabled={isPending}
              onClick={() => {
                if (step === 1) {
                  setOpen(false);
                } else {
                  setStep((prev) => prev - 1);
                }
              }}
            >
              {step === 1 ? "Fechar" : "Anterior"}
            </Button>

            <Button
              disabled={isPending}
              onClick={async () => {
                if (tutorialName === "OpenAccount" && step === 13) {
                  setStep(1);
                  setOpen(false);
                } else if (tutorialName === "CopyTrading" && step === 12) {
                  setStep(1);
                  setOpen(false);
                } else {
                  const nextStep = step + 1;
                  const meaningfulActions = userDoc.meaningfulActions || {};
                  const accountTutorial = userDoc.meaningfulActions
                    ?.accountTutorial || {
                    open: { status: true, status_date: new Date().getTime() },
                  };
                  const copyTutorial = userDoc.meaningfulActions
                    ?.copyTutorial || {
                    open: { status: true, status_date: new Date().getTime() },
                  };

                  setStep((prev) => prev + 1);

                  let lastSavedStep = 1;
                  if (tutorialName === "OpenAccount") {
                    lastSavedStep =
                      userDoc.meaningfulActions?.accountTutorial?.step || 1;
                    if (nextStep > lastSavedStep) {
                      await updateUser(user.uid, {
                        meaningfulActions: {
                          ...meaningfulActions,
                          accountTutorial: {
                            ...accountTutorial,
                            step: nextStep,
                          },
                        },
                      });
                    }
                  } else if (tutorialName === "CopyTrading") {
                    lastSavedStep =
                      userDoc.meaningfulActions?.copyTutorial?.step || 1;
                    if (nextStep > lastSavedStep) {
                      await updateUser(user.uid, {
                        meaningfulActions: {
                          ...meaningfulActions,
                          copyTutorial: {
                            ...copyTutorial,
                            step: nextStep,
                          },
                        },
                      });
                    }
                  }
                }
              }}
            >
              {getButtonText()}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
